// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"f5b22d9a","355":"3c455cd7","453":"efd7a43d","681":"0e7d3dc5","762":"f117c284","828":"bd88bcad","937":"d2cbc8cd"}[chunkId] + ".chunk.js";
};